import "./listservices.css";
import { ServicesList } from "src/Components";
import { Link } from "react-router-dom";

const Svg = ({ children, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IcPlus = () => <Svg><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></Svg>;

const ListServices = () => {
  return (
    <div className="sv-page">
      <header className="sv-hero">
        <div>
          <span className="sv-hero__eyebrow">Property setup</span>
          <h1 className="sv-hero__title">Services</h1>
          <p className="sv-hero__sub">
            The amenities and add-ons you bundle into rates — parking, breakfast,
            spa access, etc. Each service can be priced per room or per person.
          </p>
        </div>
        <div className="sv-hero__actions">
          <Link to="create" className="sv-btn sv-btn--primary">
            <IcPlus /> New service
          </Link>
        </div>
      </header>

      <ServicesList />
    </div>
  );
};

export default ListServices;
